/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFence = createReactComponent("fence", "IconFence", [
  ["path", { d: "M4 12v4h16v-4z", key: "svg-0" }],
  ["path", { d: "M6 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6", key: "svg-1" }],
  ["path", { d: "M14 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6", key: "svg-2" }]
]);

export { IconFence as default };
//# sourceMappingURL=IconFence.js.map
